class LibraryItemStore {
  constructor() {
    if (!LibraryItemStore.instance) {
      this._data = {};
      LibraryItemStore.instance = this;
      window.__LIBRARYITEMSTORE__ = this;
    }

    return LibraryItemStore.instance;
  }

  add(item) {
    this._data[item.id] = item;
  }

  get(id) {
    return this._data[id];
  }
}

var instance = new LibraryItemStore();

export default instance;
